"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubSequence = exports.Action = exports.Component = exports.Id = void 0;
const effect_1 = require("effect");
const NAMESPACE = 'Culligan.Device.Class.HydroTapBridge.RoutineSequence';
exports.Id = effect_1.Schema.Literal('restart', 'calibrate', 'flush', 'purge', 'reset').annotations({
    identifier: `${NAMESPACE}.Id`,
    description: 'The unique identifier for a HydroTap Bridge device routine sequence',
});
exports.Component = effect_1.Schema.Literal('lcd', 'boiling', 'light', 'co2', 'tank', 'filter', 'filter_counter', 'co2_counter', 'energy_usage', 'co2_sensor_zero_flow').annotations({
    identifier: `${NAMESPACE}.Component`,
});
exports.Action = effect_1.Schema.Literal('info', 'preRun', 'start', 'pause', 'resume', 'finish', 'exit').annotations({
    identifier: `${NAMESPACE}.Action`,
});
exports.SubSequence = effect_1.Schema.Literal('info', 'preRun', 'running', 'paused', 'finished').annotations({
    identifier: `${NAMESPACE}.SubSequence`,
});
//# sourceMappingURL=routine-sequence.js.map